import { render } from "./About.vue?vue&type=template&id=eca3e898"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=eca3e898&lang=css"
script.render = render

export default script